import { render } from "./ValidateForm.vue?vue&type=template&id=6f6a8cca&ts=true"
import script from "./ValidateForm.vue?vue&type=script&lang=ts"
export * from "./ValidateForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__